<template>
  <!-- Call to action, v2 layouts (band | card). Sections without a v2 layout
       still use CTASection, so existing sites don't change. -->
  <SectionFrame :section="section" :index="index" label="Call to action">
    <div :class="layout === 'card' ? 't-card s2-cta-card' : 's2-cta-band'" class="mo-reveal">
      <div>
        <component :is="headingTag" class="t-h2 s2-cta-title">{{ section.title }}</component>
        <div v-if="html" class="t-body s2-cta-text" v-html="html"></div>
      </div>
      <a v-if="section.callToAction" class="t-btn" :href="back(href)">{{ section.callToAction }}</a>
    </div>
  </SectionFrame>
</template>

<script setup>
import {useSectionHeadingTag} from "@/composables/useSectionHeadingTag.js";
import {computed} from "vue";
import SectionFrame from "./SectionFrame.vue";
import {layoutOf} from "@/utils/sectionLogic.js";
import {contentHtml} from "@/utils/contentHtml.js";
import {useBackLinks} from "@/composables/useBackLinks.js";
const back = useBackLinks();
const headingTag = useSectionHeadingTag();

const props = defineProps({section: {type: Object, required: true}, index: {type: Number, default: 0}});
const layout = computed(() => layoutOf(props.section, ["band", "card"]));
const html = computed(() => contentHtml(props.section.content || ""));
const href = computed(() => {
  const n = String(props.section.navigateTo || props.section.link || "");
  if (/^(\/|https?:\/\/|tel:|mailto:|#)/i.test(n)) return n;
  return props.section.scrollTarget ? `#${props.section.scrollTarget}` : "/contact";
});
</script>

<style>
.s2-cta-band { display: flex; align-items: center; justify-content: space-between; gap: 1.5rem 2rem; flex-wrap: wrap; }
.s2-cta-card { display: flex; flex-direction: column; align-items: center; text-align: center; gap: 1.25rem; max-width: 720px; margin: 0 auto; }
.s2-cta-title { margin: 0; }
.s2-cta-text { margin-top: .5rem; color: var(--t-muted); max-width: 60ch; }
</style>
